
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, minValue, maxLength } from 'vuelidate/lib/validators';
  import { EventBus } from '@/event-bus';

  import {
    EnumModel,
    JobItemType,
    JobItemTypeEnums,
    JobItemTypeEnumsGeneric,
    EnumModelGeneric
  } from '@/common/enumerations';
  import { Client, IServiceTypeModel, ServiceTypeModel, ServiceTypeUpdateModel } from '@/services/api.service';
  import { ServiceTypeUpdatedMessage } from '@/services/eventbus.models';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import * as StringUtils from '@/utilities/string.utils';

  @Component({
    props: {
      serviceType: {
        type: Object as () => IServiceTypeModel,
        required: false
      },
      isInDialogMode: Boolean
    },
    filters: {
      toJobItemType: toJobItemTypeFormatter
    }
  })
  export default class ServiceTypeEdit extends Vue {
    private name: string = '';
    private description: string = '';
    private accountCode: string = '';
    private baseRate: number = 0;
    private isUnitRate: boolean = false;
    private gid: string = '';
    private availableJobItemTypes: EnumModel[] = [];
    private selectedJobItemType: number = 0;

    public formIsValid: boolean | null = null;

    @Validations()
    private validations = {
      name: { required }
    };

    private mounted() {
      this.availableJobItemTypes.push(
        ...JobItemTypeEnumsGeneric.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''))
      );
      const anyJobItemTypeModel: EnumModel = new EnumModel('(Any Job Type)', 0);
      this.availableJobItemTypes.unshift(anyJobItemTypeModel);
      this.selectedJobItemType = anyJobItemTypeModel.value;

      if (this.$props.serviceType) {
        this.name = this.$props.serviceType.name;
        this.description = this.$props.serviceType.description;
        this.accountCode = this.$props.serviceType.accountCode;
        this.baseRate = this.$props.serviceType.baseRate;
        this.isUnitRate = this.$props.serviceType.isUnitRate;
        this.gid = this.$props.serviceType.gid;
        this.selectedJobItemType = this.$props.serviceType.parentJobType;
      }
    }

    private updateServiceType() {
      // Do the work here
      // Run the validation
      // @ts-ignore
      this.$v.$touch();
      const me = this;
      // @ts-ignore
      if (me.$v.$invalid) {
        this.formIsValid = false;
        console.log('Submit failed. Form is invalid.');
      } else {
        // do your submit logic here
        me.formIsValid = true;
        console.log('Submit started. Form valid.');
        const updateServiceType: ServiceTypeUpdateModel = new ServiceTypeUpdateModel();

        updateServiceType.init({
          gid: this.gid,
          name: this.name,
          description: this.description,
          accountCode: this.accountCode,
          parentJobType: this.selectedJobItemType,
          baseRate: this.baseRate,
          isUnitRate: this.isUnitRate,
          isDeleted: false
        });
        console.log(updateServiceType);
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        // @ts-ignore
        me.$Progress.start();
        clientService.updateServiceType(this.gid, updateServiceType).then((data: ServiceTypeModel) => {
          // Route to the edit job list screen?
          console.log('Returned service type:');
          console.log(data);
          // @ts-ignore
          me.$Progress.finish();
          // @ts-ignore
          me.$awn.success('Service type ' + me.name + ' updated successfully');
          me.$emit('servicetype-updated', data);
          EventBus.$emit('servicetype-updated', new ServiceTypeUpdatedMessage(data));
          me.closeModal();
        });
      }
    }
    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      this.$modal.hide('modal-servicetype-edit');
    }
  }
